import { AppInput, AppSelect } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { INDUSTRY_GROUPS } from 'shared'
import { AppWorkLocationCheckboxGroup } from '@/components/AppWorkLocationCheckboxGroup'
import { useFormattedNumberInput } from '@/hooks/useFormattedNumberInput'
import { useWorkLocationFields } from '@/hooks/useWorkLocationFields'
import { formatCurrency } from '@/lib/format-utils'
import type { InquiryEditFormValues } from '../../../hooks/useInquiryEditForm'

type AmountDetailsSectionProps = {
  totalAssignAmount: number | null
  formValues: InquiryEditFormValues
  formErrors: Partial<Record<keyof InquiryEditFormValues, string>>
  onFieldChange: <K extends keyof InquiryEditFormValues>(key: K, value: InquiryEditFormValues[K]) => void
  isInquiryCompleted?: boolean
}

export function AmountDetailsSection({
  totalAssignAmount,
  formValues,
  formErrors,
  onFieldChange,
  isInquiryCompleted,
}: AmountDetailsSectionProps) {
  const estimatedAmountInputProps = useFormattedNumberInput(formValues.estimatedAmount, (raw) =>
    onFieldChange('estimatedAmount', raw),
  )
  const workLocationProps = useWorkLocationFields(formValues, onFieldChange)

  return (
    <fieldset disabled={isInquiryCompleted} className='space-y-3 disabled:cursor-not-allowed'>
      <legend className='text-base font-semibold'>金額・詳細</legend>
      <div className='grid grid-cols-1 gap-4 md:grid-cols-3'>
        <AppInput label='想定金額' {...estimatedAmountInputProps} error={formErrors.estimatedAmount} />
        <AppInput
          label='アサイン金額'
          value={totalAssignAmount != null ? formatCurrency(totalAssignAmount) : '-'}
          disabled
        />
        {/* AppSelect のトリガーは既定で min-w-50（200px）のため、3列の grid では列からはみ出す。他の欄と同じく列幅に収める */}
        <AppSelect
          label='業界'
          className='min-w-0'
          value={formValues.industryName}
          onValueChange={(value) => onFieldChange('industryName', value)}
          options={INDUSTRY_GROUPS.map((group) => ({ value: group, label: group }))}
          placeholder='選択してください'
          disabled={isInquiryCompleted}
          clearable={!isInquiryCompleted}
          onClear={() => onFieldChange('industryName', '')}
          error={formErrors.industryName}
        />
        <AppInput
          label='最寄り駅'
          value={formValues.station}
          onChange={(e) => onFieldChange('station', e.target.value)}
          error={formErrors.station}
        />
        <AppWorkLocationCheckboxGroup label='作業場所' className='md:col-span-2' {...workLocationProps} />
      </div>
    </fieldset>
  )
}
